import {useCallback, useState} from "react";
import {
	SelectUserAll,
	DateField
} from "~/components/Forms";
import {strToTime} from "~/utils";

function SabbaticalSearchBar({filter, onChange}) {

	const [optionsUser, setOptionsUser] = useState([{value:'', label:'Tất cả'}]);

	const handleUserChange = useCallback((value) => {
		if (onChange) { onChange('userId', value); }
	}, [onChange]);

	const handleTimeChange = useCallback((value) => {
		value = strToTime(value);
		if(onChange) onChange('startDate', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<SelectUserAll  value={filter.userId} placeholder="Nhân viên" options={optionsUser} setOptions={setOptionsUser} onChange={handleUserChange} />
					<DateField value={filter.time} name="startDate" placeholder="Ngày bắt đầu off" onChange={handleTimeChange}/>
				</form>
			</div>
		</div>
	)
}

export default SabbaticalSearchBar;